import Button from "../../../../../shared/lib/html5-software-library/src/ranj/components/buttons/Button";
import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import GameModel from "../core/model/GameModel";
import ScenarioState from "../core/model/ScenarioState";
import AbstractCollaborationScreenMediator from "../core/view/AbstractCollaborationScreenMediator";
import ScenarioLibrary from "../ngt/scenario/ScenarioLibrary";
import ScenarioCommandEvent from "../ngt/scenario/controller/ScenarioCommandEvent";

export default class EpisodeSelectionScreenMediator extends AbstractCollaborationScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets  
     * @param {ScenarioLibrary} scenarioLibrary
     * @param {GameModel} gameModel
     */
    constructor(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, scenarioLibrary, gameModel, mediatorManager) {
        super(target, dispatcher, languagePack, layoutManager, soundManager, gameAssets, gameModel, mediatorManager);

        this._scenarioLibrary = scenarioLibrary;
        this._gameModel = gameModel;
        this._onScenarioPressedBound = this._onScenarioPressed.bind(this);
        /** @type {Button[]} */
        this._episodeButtons = [];
    }

    initialize() {
        super.initialize();

        this._target.bodyTextfield.text = this.getText("episodeSelection.description");
        this.anchorObject(this._target.bodyTextfield, Anchor.T);

        this._initializeEpisodeButtons();

        this._fadeIn();
    }

    _initializeEpisodeButtons() {
        const scenarioStates = this._gameModel.scenarioStates;

        const templateButton = this._target.episodeButton;
        const buttonSkinType = this._gameAssets.EpisodeButton;
        const container = templateButton.parent;
        const ySpacing = templateButton.getBounds().height + 10;
        let yOffset = 0;

        // initialize buttons based on the available Scenario States
        for (const scenarioState of scenarioStates) {
            const scenario = this._scenarioLibrary.getScenarioByID(scenarioState.id);

            const buttonSkin = new buttonSkinType();
            const isScenarioCompleted = scenarioState.state === ScenarioState.STATE_FINISHED;
            const buttonIcon = isScenarioCompleted ? scenario.completedIcon : scenario.availableIcon;
            buttonSkin.completedTextField.text = this._languagePack.getText("episodeSelection.completedEpisode");
            buttonSkin.imageContainer.gotoAndStop(buttonIcon);
            container.addChild(buttonSkin);
            buttonSkin.x = templateButton.x;
            buttonSkin.y = templateButton.y + yOffset;
            buttonSkin.parameters = {
                scenario: scenario,
            };
            this.anchorObject(buttonSkin, Anchor.T);

            const label = this.getText(scenario.name);
            const button = this.createButton(buttonSkin, this._onScenarioPressedBound, label);
            button.setEnabled(!isScenarioCompleted);
            this._episodeButtons.push(button);

            yOffset += ySpacing;
        }

        // animate buttons in
        for (let i = 0, delay = 600; i < this._episodeButtons.length; i++, delay += 250) {
            const buttonSkin = this._episodeButtons[i].skin;
            this._initForAnimation(buttonSkin);
            this._animateOptionButtonIn(buttonSkin, delay);
        }

        templateButton.visible = false;
    }

    /**
     * 
     * @param {{target: Button}} evt 
     */
    _onScenarioPressed({ target }) {
        const scenario = target.skin.parameters.scenario;
        console.log(`[EpisodeSelectionScreenMediator] Play scenario id ${scenario.id}`);
        this._fadeOut(() => {
            this.dispatch(ScenarioCommandEvent.PLAY_SCENARIO, { scenarioId: scenario.id });
        });
    }

    _initForAnimation(target) {
        target.yOrig = target.y;
        target.scaleOrig = target.scaleY;
    }

    _animateOptionButtonIn(target, delay) {
        target.visible = true;
        target.alpha = 0;
        target.scaleX = target.scaleY = .1 * target.scaleOrig;
        createjs.Tween.get(target)
            .wait(delay / this._speedFactor)
            .to({ alpha: 1, scaleX: target.scaleOrig, scaleY: target.scaleOrig }, 250 / this._speedFactor, createjs.Ease.backOut);
    }
}
